import React, { useEffect, useState } from 'react';
import { XIcon, CheckCircleIcon } from 'lucide-react';
const RECENT_PURCHASES = [{
  name: 'María',
  location: 'Ciudad de México, MX'
}, {
  name: 'Ana',
  location: 'Bogotá, CO'
}, {
  name: 'Sofía',
  location: 'Lima, PE'
}, {
  name: 'Elena',
  location: 'Madrid, ES'
}, {
  name: 'Valentina',
  location: 'Buenos Aires, AR'
}, {
  name: 'Camila',
  location: 'Santiago, CL'
}, {
  name: 'Isabella',
  location: 'Miami, US'
}, {
  name: 'Lucía',
  location: 'Montevideo, UY'
}, {
  name: 'Gabriela',
  location: 'San José, CR'
}, {
  name: 'Martina',
  location: 'Asunción, PY'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchase, setPurchase] = useState(RECENT_PURCHASES[0]);
  const [hasStarted, setHasStarted] = useState(false);
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    const showPopup = () => {
      // Pick a random purchase that is different from the current one if possible
      setPurchase(prev => {
        let next;
        do {
          next = RECENT_PURCHASES[Math.floor(Math.random() * RECENT_PURCHASES.length)];
        } while (next === prev && RECENT_PURCHASES.length > 1);
        return next;
      });
      setIsVisible(true);
      // Hide after 6 seconds
      timeoutId = setTimeout(() => {
        setIsVisible(false);
        // Schedule next popup after 45 seconds
        timeoutId = setTimeout(showPopup, 45000);
      }, 6000);
    };
    // Initial start delay of 30 seconds
    if (!hasStarted) {
      timeoutId = setTimeout(() => {
        setHasStarted(true);
        showPopup();
      }, 30000);
    }
    return () => clearTimeout(timeoutId);
  }, [hasStarted]);
  if (!hasStarted && !isVisible) return null;
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-700 ease-in-out transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'}`} data-id="element-199">
      <div className="bg-navy-800 border border-gold-500/30 rounded-xl shadow-2xl shadow-black/50 p-4 max-w-sm flex items-center gap-4 relative overflow-hidden" data-id="element-200">
        {/* Close button */}
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-cream-100/40 hover:text-cream-100 transition-colors" aria-label="Cerrar notificación" data-id="element-201">
          <XIcon className="w-4 h-4" data-id="element-202" />
        </button>

        {/* Product Image */}
        <div className="flex-shrink-0 w-16 h-20 bg-navy-900 rounded-md overflow-hidden border border-navy-700 relative" data-id="element-203">
          <img src="https://cdn.magicpatterns.com/uploads/wKFgBSYtCjCnjAkjTNtBBK/heylloyd-image-1771466099503.png" alt="Libro Digital" className="w-full h-full object-cover" data-id="element-204" />
        </div>

        {/* Content */}
        <div className="pr-6" data-id="element-205">
          <div className="flex items-center gap-1.5 mb-1" data-id="element-206">
            <CheckCircleIcon className="w-3.5 h-3.5 text-green-400" data-id="element-207" />
            <span className="text-xs font-bold text-green-400 uppercase tracking-wide" data-id="element-208">
              Compra Reciente
            </span>
          </div>
          <p className="text-sm text-cream-50 font-medium leading-tight mb-1" data-id="element-209">
            <span className="font-bold text-gold-400" data-id="element-210">{purchase.name}</span> de{' '}
            {purchase.location}
          </p>
          <p className="text-xs text-cream-100/60" data-id="element-211">
            Compró <strong data-id="element-212">Sueño y Serenidad</strong>
          </p>
          <p className="text-[10px] text-cream-100/40 mt-1" data-id="element-213">
            hace unos momentos
          </p>
        </div>

        {/* Glow effect */}
        <div className="absolute -top-10 -left-10 w-20 h-20 bg-gold-500/10 blur-2xl rounded-full pointer-events-none" data-id="element-214" />
      </div>
    </div>;
}